<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.63 11.21a1 1 0 01-1.38 0l-2.92-2.6a1 1 0 111.34-1.48l2.22 2 4.41-4.34a1 1 0 111.4 1.42z"/></svg>